var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatPage"},[_c('card',{staticClass:"chatWrapper"},[_c('ReChatWrapper',{attrs:{"bIsActiveLeft":_vm.bIsActiveLeft,"bIsSwitch":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }